var styleDataHash = "b20eadc6";
const injectCss = () => {
  var css = `.-Bj3c,.wHDC7{height:386px;overflow:auto}[dir] .-Bj3c,[dir] .wHDC7{margin-top:20px}[dir=ltr] .-Bj3c,[dir=ltr] .wHDC7{margin-right:-16px;padding-right:16px}[dir=rtl] .-Bj3c,[dir=rtl] .wHDC7{margin-left:-16px;padding-left:16px}.-Bj3c.jvtr8,.wHDC7.jvtr8{height:calc(100vh - 190px)}.hxBv9{display:flex;flex-direction:column}[dir=ltr] ._6ZZlC{float:right;text-align:right}[dir=rtl] ._6ZZlC{float:left;text-align:left}[dir] .Z9Bbg{cursor:pointer}.Z9Bbg:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.OCWIB{align-items:center;display:flex;height:100%;justify-content:center;width:100%}[dir] .OCWIB{margin-top:50px}.fs---{height:100%;width:100%}.-Bj3c,.fs---{align-items:center;display:flex;justify-content:center}.-Bj3c{max-width:100%}.yh6Op{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selector_default = {
  "giphy_selector_infinite_scroll_container": "wHDC7",
  "giphySelectorErrorContainer": "-Bj3c",
  "mobile": "jvtr8",
  "giphy_selector_infinite_scroll": "hxBv9",
  "giphy_selector_powerdByGiphy": "_6ZZlC",
  "giphy_selector_gif_img_container": "Z9Bbg",
  "giphy_selector_spinner_load_more": "OCWIB",
  "giphy_selector_spinner_empty_modal": "fs---",
  "searchInput": "yh6Op"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
